import api from "./api";


export async function getPendingDebitNoteItems(purchase_return_id) {
  try {
    const response = await api.get(`debit-notes/check-products/`, {
      params: { purchase_return_id: purchase_return_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getPendingCreditNoteItems(sales_return_id) {
  try {
    const response = await api.get(`credit-notes/check-products/`, {
      params: { sales_return_id: sales_return_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getDebitNotes(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`debit-notes/details/${id}/`);
      return response.data;
    } else {
      const response = await api.get("debit-notes/", { params });
      return response.data;
    }
  } catch (error) {
    throw error
  }
}

export async function CreateDebitNote(formData) {
  try {
    const response = await api.post("debit-notes/create/", formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function ConfirmDebitNote(uuid) {
  try {
    const response = await api.post(
      `debit-notes/${uuid}/confirm/`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function CancelDebitNote(uuid) {
  try {
    const response = await api.post(
      `debit-notes/${uuid}/cancel/`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}


export async function CheckDebitNotePaymentStatus(debit_note_id) {
  try {
    const response = await api.get(`debit-notes/payment-status/`, {
      params: { debit_note_id: debit_note_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function CheckCreditNotePaymentStatus(credit_note_id) {
  try {
    const response = await api.get(`credit-notes/payment-status/`, {
      params: { credit_note_id: credit_note_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function DebitNotesArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("debit-notes/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`debit-notes/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error
  }
}



export async function getCreditNotes(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`credit-notes/details/${id}/`);
      return response.data;
    } else {
      const response = await api.get("credit-notes/", { params });
      return response.data;
    }
  } catch (error) {
    throw error
  }
}

export async function CreditNoteCreate(formData) {
  try {
    const response = await api.post(
      "credit-notes/create/",
      formData
    );
    return response;
  } catch (error) {
    throw error
  }
}


export async function ConfirmCreditNote(uuid) {
  try {
    const response = await api.post(
      `credit-notes/${uuid}/confirm/`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function CancelCreditNote(uuid) {
  try {
    const response = await api.post(
      `credit-notes/${uuid}/cancel/`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function CreditNoteArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("credit-notes/archive/", {
        id_list: id_list,
      });
      console.log("res",response)
    } else {
      response = await api.get(`credit-notes/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error
  }
}